import { Stack, Button, Box } from "@mui/material";
import { DataGrid, GridColDef, GridRowSelectionModel } from "@mui/x-data-grid";
import TableSkelton from "components/common/SkeltonComponent/TableSkelton";
import React, { useState } from "react";

function UserListTable(props: any) {
  const { users, authAction } = props;
  const [selectionModel, setSelectionModel] = useState<GridRowSelectionModel>([]);
  const [loading, setLoading] = useState(false);

  const handleAuthAction = (userUuid: string, cpoUuid: string, isAuthorise: boolean) => {
    console.log(`Authorizing CPO with UUID: ${cpoUuid} for user UUID: ${userUuid}`);
    // TODO: Call your API here to authorize the token
    authAction(userUuid, cpoUuid, isAuthorise);
  };

  const columns: GridColDef[] = [
    {
      field: "firstName",
      headerName: "First Name",
      sortable: false,
      width: 100,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "lastName",
      headerName: "Last Name",
      align: "center",
      headerAlign: "center",
      width: 100,
    },
    {
      field: "emailAddress",
      headerName: "Email Address",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "role",
      headerName: "Role",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "state",
      headerName: "Status",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "vrnListAsString",
      headerName: "Vehicles",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "actions",
      headerName: "CPO Actions",
      sortable: false,
      align: "center",
      headerAlign: "center",
      width: 400,
      renderCell: (params) => (
        <Box
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "left",
            alignItems: "left",
          }}
        >
          <Stack direction="row" spacing={1}>
            {params.row.tokens.map((token: any) => (
              <Button
                key={token.cpoUuid}
                variant="contained"
                color={token.tokenStatus === "UNAUTHORISED" ? "primary" : "warning"}
                size="small"
                onClick={() =>
                  handleAuthAction(params.row.uuid, token.cpoUuid, token.tokenStatus === "UNAUTHORISED")
                }
              >
                {token.tokenStatus === "UNAUTHORISED" ? `Authorise` : `DeAuthorise`}
              </Button>
            ))}
          </Stack>
        </Box>
      ),
    },
        
  ];

  return (
    <>
      {loading ? (
        <TableSkelton />
      ) : (
        <div className="table-box">
          <DataGrid
            rows={users}
            autoHeight
            columns={columns}
            initialState={{ pagination: { paginationModel: { pageSize: 10, page: 0 } } }}
            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              noRowsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  <span>No Users have been found.</span>
                </Stack>
              ),
              noResultsOverlay: () => (
                <Stack height="100%" alignItems="center" justifyContent="center">
                  Selected filter returned no results
                </Stack>
              ),
            }}
          />
        </div>
      )}
    </>
  );
}

export default UserListTable;
